import type { Patient } from "@louise/medical-history/basic-info/calculateBasicInfoCompletion";

/**
 * Backend gap: the OpenAPI schema exposes `hasContraceptionHistory` on
 * `obGynHistory` but not on `maleHistory`. Until the backend adds it, an AMAB
 * user answering "no" has nowhere to persist the answer. We still read the
 * field here (via a runtime cast) so the flow lights up automatically the
 * moment the backend surfaces it.
 */
export function calculateContraceptionCompletion(
  patient: Patient | null | undefined,
) {
  const isMale = patient?.gender === "AMAB";

  const maleFlag = (
    patient?.maleHistory as
      | { hasContraceptionHistory?: boolean | null }
      | undefined
  )?.hasContraceptionHistory;

  const hasAnswered = isMale
    ? maleFlag != null ||
      (patient?.maleHistory?.contraceptions ?? []).length > 0
    : patient?.obGynHistory?.hasContraceptionHistory != null;

  const fields = [hasAnswered];

  const completed = fields.filter(Boolean).length;
  const total = fields.length;

  return {
    percent: total > 0 ? completed / total : 0,
    label: `${completed}/${total} answered`,
    completed,
    total,
  };
}
